import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const LikeCommentButton = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitLikeToggle = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    try {
      const url = `/ajax/audio/${props.audioId}/comment/${props.commentId}/like`;
      if (props.liked) {
        await axios.delete(url);
      } else {
        await axios.post(url);
      }
      if (props.likeStatusChangedHandler) {
        await props.likeStatusChangedHandler();
      }
    } catch {
      // Keep the current UI state when the request fails.
    } finally {
      setIsSubmitting(false);
    }
  };

  let statusClass = 'opacity-50';
  if (props.canLike) {
    if (isSubmitting) {
      statusClass = 'opacity-25 pe-none';
    } else {
      statusClass = '';
    }
  }

  return (
    <span className="d-inline-flex align-items-center">
      <a
        type={props.canLike ? 'button' : undefined}
        className={`text-body text-decoration-none p-0 ${statusClass}`}
        onClick={props.canLike ? submitLikeToggle : undefined}
      >
        <i className={`icon-heart${props.liked ? '' : '-o'} color-heart kfs-5`}></i>
      </a>
      <span className="ms-1">{props.likesCount}</span>
    </span>
  );
};

LikeCommentButton.propTypes = {
  audioId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  commentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  canLike: PropTypes.bool,
  liked: PropTypes.bool,
  likesCount: PropTypes.number,
  likeStatusChangedHandler: PropTypes.func,
};

export default LikeCommentButton;
